// @ts-nocheck
// components/ControlledSelect.tsx
import React, { useState } from 'react';
import { Select as MUISelect } from '@mui/material';
import type { SelectProps, SelectChangeEvent } from '@mui/material';

const ControlledSelect = <T,>({ onChange, onClose, children, ...selectProps }: SelectProps<T>) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = (event: React.SyntheticEvent) => {
    setIsClosing(true);
    onClose?.(event);

    // Reset closing state after animation completes
    setTimeout(() => setIsClosing(false), 0);
  };

  const handleChange = (e: SelectChangeEvent<any>) => {
    if (isClosing) {
      return;
    }
    onChange?.(e, e.target.value);
  };

  return (
    <MUISelect {...selectProps} onClose={handleClose} onChange={handleChange}>
      {children}
    </MUISelect>
  );
};

export default ControlledSelect;
